import React from 'react';

export default function ComponentWeb({children}) {
    return <div className={'d-none d-xs-none d-sm-none d-md-block d-lg-block'}>
        {children}
    </div>
}
